// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_AtualizaFormasPagamentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /contas/atualiza_formas_pagamento/{id}
 *
 * Echoes the conta_id whose payment-method links were rewritten.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Contas_AtualizaFormasPagamentoResponseDados {
conta_id: number
}

export type Contas_AtualizaFormasPagamentoResponse = ApiResponse<Contas_AtualizaFormasPagamentoResponseDados>;

registerResponseContract('Contas_AtualizaFormasPagamentoResponse', {
  conta_id: { type: 'number',  required: true },
})
